export { SpaClassBookingForm } from './SpaClassBookingForm';
export type {
  SpaClassBookingFormLabels,
  SpaClassBookingFormProps,
  SpaClassGuestConfig,
} from './SpaClassBookingForm.types';
